import { render } from "./RightBuoy2.vue?vue&type=template&id=b32c1e70&scoped=true"
import script from "./RightBuoy2.vue?vue&type=script&lang=js"
export * from "./RightBuoy2.vue?vue&type=script&lang=js"

import "./RightBuoy2.vue?vue&type=style&index=0&id=b32c1e70&lang=less&scoped=true"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32c1e70"]])

export default __exports__